/*
Team endpoints (tenant-scoped, require users:manage):
  GET   /api/team/members                    -> Member[]  (Invited members include `inviteCode` so the admin can share it)
  POST  /api/team/members                    { email, role }  -> Member { status: "Invited", inviteCode }
  PATCH /api/team/members/:id                { role }         -> Member
  POST  /api/team/members/:id/status         { status: "Active" | "Deactivated" } -> { id, status, result }
Roles: Admin | Editor | Viewer (Owner is created at registration and can't be changed or deactivated).
*/
import { apiClient } from "../../api/apiClient";

const send = (url, method, body) => apiClient(url, { method, body: JSON.stringify(body) }).then((res) => res.data);

export const listTeamUsers = () => apiClient("/api/team/members").then((res) => res.data);

export async function inviteTeamUser({ email, role }) {
  if (!email || !email.trim()) throw new Error("Email address is required.");
  return send("/api/team/members", "POST", { email: email.trim(), role });
}

export async function updateTeamUserRole(userId, { role }) {
  if (!userId) throw new Error("User ID is required.");
  const updated = await send(`/api/team/members/${userId}`, "PATCH", { role });
  return { id: updated.id, role: updated.role, status: "success" };
}

/* Activate / deactivate a team member. */
export async function setTeamUserStatus(userId, { status }) {
  if (!userId) throw new Error("User ID is required.");
  const result = await send(`/api/team/members/${userId}/status`, "POST", { status });
  return { id: result.id, status: result.status, result: "success" };
}
